import { Fragment, useEffect, useState } from "react"
import { Popover, Transition } from "@headlessui/react"
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline"
import { selectUser } from "../features/userSlice"
import { useSelector } from "react-redux"
import Logo from "./Logo"
import Link from "next/link"
import WhyParagraphMenu from "components/landing/WhyParagraphMenu"
//import LogoText from "../public/logo_with_text.png"
import LogoWithText from "./LogoWithText"
import Button from "./Button"

//const navigation = [{ name: "Pricing", href: "/pricing" }]
const navigation: any[] = []

export default function Navbar() {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false)
  const user = useSelector(selectUser)

  useEffect(() => {
    setIsUserLoggedIn(!!user?.id)
  }, [user])

  return (
    <Popover as="header" className="relative z-20">
      {({ open }) => (
        <div>
          <div className="py-2">
            <nav
              className="relative flex items-center justify-between px-4 mx-auto max-w-7xl sm:px-6"
              aria-label="Global"
            >
              <div className="flex items-center flex-1">
                <div className="flex items-center justify-between w-full md:w-auto">
                  <span className="sr-only">Paragraph</span>
                  <LogoWithText
                    color="white"
                    className="cursor h-14 w-auto"
                    href="/"
                  />
                  <div className="flex items-center -mr-2 md:hidden">
                    <Popover.Button className="inline-flex items-center justify-center p-2 text-white rounded-md hover:bg-gray-800 focus:outline-none focus:ring-2 focus-ring-inset focus:ring-white">
                      <span className="sr-only">Open main menu</span>
                      <Bars3Icon className="w-6 h-6" aria-hidden="true" />
                    </Popover.Button>
                  </div>
                </div>
                <div className="hidden space-x-8 md:flex md:ml-10">
                  {navigation.map((item) => (
                    <button
                      key={item.name}
                      className="text-base font-medium text-white hover:text-gray-300"
                    >
                      <Link href={item.href} legacyBehavior>
                        {item.name}
                      </Link>
                    </button>
                  ))}
                  <WhyParagraphMenu
                    openClassNames="text-white"
                    closeClassNames="text-white font-semibold text-base"
                  />
                </div>
              </div>
              <div className="hidden md:flex md:items-center md:space-x-6">
                <button className="text-base font-medium text-white hover:text-gray-300">
                  <Link href="/@blog">Our Newsletter</Link>
                </button>

                <button className="text-base font-medium text-white hover:text-gray-300">
                  <a
                    href="https://docs.paragraph.xyz"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Docs
                  </a>
                </button>
                <button className="text-base font-medium text-white hover:text-gray-300">
                  <Link href="/discover/feed/trending/paragraph">Discover</Link>
                </button>
                {!isUserLoggedIn && (
                  <div className="">
                    <Link href="/login">
                      <Button
                        text="Log in"
                        replaceClassName="text-base font-medium text-white hover:text-gray-300"
                      />
                    </Link>

                    <Link href="/register" className="pl-6">
                      <Button
                        text="Get started"
                        replaceClassName="inline-flex items-center px-4 py-2 text-base font-medium text-blue-600 border border-transparent rounded-md hover:bg-blue-100 bg-white"
                      />
                    </Link>
                  </div>
                )}
                {isUserLoggedIn && (
                  <div>
                    <Link href="/notes" className="relative">
                      <Button
                        text="Continue to dashboard"
                        replaceClassName="inline-flex items-center px-4 py-2 text-base font-medium text-blue-600 border-1 bg-white border border-transparent rounded-md hover:bg-blue-100 relative "
                      />
                    </Link>
                  </div>
                )}
              </div>
            </nav>
          </div>

          <Transition
            show={open}
            as={Fragment}
            enter="duration-150 ease-out"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="duration-100 ease-in"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Popover.Panel
              focus
              static
              className="absolute inset-x-0 top-0 p-2 transition transform origin-top md:hidden"
            >
              <div className="overflow-hidden bg-white rounded-lg shadow-md ring-1 ring-black ring-opacity-5">
                <div className="flex items-center justify-between px-5 pt-4">
                  <div>
                    <Logo className="w-auto h-10 sm:h-12" />
                  </div>
                  <div className="-mr-2">
                    <Popover.Button className="inline-flex items-center justify-center p-2 text-gray-400 bg-white rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-600">
                      <span className="sr-only">Close menu</span>
                      <XMarkIcon className="w-6 h-6" aria-hidden="true" />
                    </Popover.Button>
                  </div>
                </div>
                <div className="pt-5 pb-6">
                  <div className="px-2 space-y-1">
                    {navigation.map((item) => (
                      <button
                        key={item.name}
                        className="block px-3 py-2 text-base font-medium text-gray-900 rounded-md hover:bg-gray-50"
                      >
                        <Link href={item.href} legacyBehavior>
                          {item.name}
                        </Link>
                      </button>
                    ))}

                    <WhyParagraphMenu
                      openClassNames="text-white"
                      closeClassNames="text-white font-semibold text-base"
                    />

                    <button className="block px-3 py-2 text-base font-medium text-gray-900 rounded-md hover:bg-gray-50">
                      <Link href="/@blog">Our Newsletter</Link>
                    </button>

                    <button className="block px-3 py-2 text-base font-medium text-gray-900 rounded-md hover:bg-gray-50">
                      <a
                        href="https://docs.paragraph.xyz"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Documentation
                      </a>
                    </button>
                    <button className="block px-3 py-2 text-base font-medium text-gray-900 rounded-md hover:bg-gray-50">
                      <Link href="/discover/feed/trending/paragraph">
                        Discover
                      </Link>
                    </button>
                  </div>
                  {!isUserLoggedIn && (
                    <div>
                      <div className="px-5 mt-6">
                        <Link href="/register" legacyBehavior>
                          <button className="block w-full px-4 py-3 font-medium text-center text-white bg-blue-600 shadow cursor-pointer rounded-md hover:bg-blue-700">
                            Get started
                          </button>
                        </Link>
                      </div>
                      <div className="px-5 mt-6">
                        <p className="text-base font-medium text-center text-gray-500">
                          Existing user?{" "}
                          <Link href="/login" legacyBehavior>
                            <button className="text-gray-900 cursor-pointer hover:underline">
                              Login
                            </button>
                          </Link>
                        </p>
                      </div>
                    </div>
                  )}
                  {isUserLoggedIn && (
                    <div>
                      <div className="px-5 mt-6">
                        <Link href="/notes" legacyBehavior>
                          <button className="block w-full px-4 py-3 font-medium text-center text-white bg-blue-600 shadow cursor-pointer rounded-md hover:bg-blue-700">
                            Continue to dashboard
                          </button>
                        </Link>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </div>
      )}
    </Popover>
  )
}
